var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.loaded && _vm.documents.length == 0
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.documents.length == 0
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.attachments.none"))),
        ])
      : _c(
          "div",
          { staticClass: "sidebar-attachments" },
          _vm._l(_vm.documents, function (doc) {
            return _c(
              "a",
              {
                key: doc.ID,
                staticClass: "sidebar-attachment",
                attrs: {
                  href: doc.getUrl(),
                  target: "_blank",
                  rel: "noopener",
                },
              },
              [
                _c("w-fa", {
                  staticClass: "sidebar-attachment-icon",
                  attrs: { icon: _vm.iconFor(doc) },
                }),
                _c("span", { staticClass: "sidebar-attachment-name" }, [
                  _vm._v(_vm._s(doc.getName())),
                ]),
                _c("w-fa", {
                  staticClass: "sidebar-attachment-open",
                  attrs: { icon: "external-link-alt" },
                }),
              ],
              1
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }